export default "__VITE_ASSET__D7zYos75__"